import createReactComponent from '../createReactComponent';
export default createReactComponent('alarm-x', 'AlarmX', [["path",{"d":"M3 5.231 6.15 3M21 5.231 17.85 3M20 13a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-10-2 4 4m0-4-4 4","key":"svg-0"}]]);